import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=1384a292&"
import script from "./AlertView.vue?vue&type=script&lang=ts&"
export * from "./AlertView.vue?vue&type=script&lang=ts&"
import style0 from "./AlertView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports